export function getDataExtensoSimples(strData: string) {
    var dateParts = strData.split("/");
    var dt = new Date(parseInt(dateParts[2], 10),
                      parseInt(dateParts[1], 10) - 1,
                      parseInt(dateParts[0], 10));
    var day = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"][dt.getDay()];                      
    var month = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"][dt.getMonth()];
    return day + " ∙ " + parseInt(dateParts[0], 10).toString() + " de " + month + " de " + parseInt(dateParts[2], 10).toString();
}

/**
 * PLACE_ID sempre tem que ser um número válido, é ajustado lá no App.tsx. Se não tiver esse param, lá é fornecido o id
 * da loja demo.
 * @param place_id
 * @param tableNumber
 * @param customOrigin
 */
export function getSearchParams(place_id: string, tableNumber: string | undefined | null, customOrigin: string | undefined | null){

    const tableNumbeEmNumero = Number(tableNumber ?? -1) ?? -1
    const customOriginEmNumero = Number(customOrigin ?? -1)??-1


    const paramsTable = tableNumbeEmNumero > 0
      ? `&table=${tableNumbeEmNumero}`
      : ''

    const paramsCustomOrigin = customOriginEmNumero > 0
      ? `&origin=${customOriginEmNumero}`
      : ''

    return`?place_id=${place_id}${paramsCustomOrigin}${paramsTable}`
}